import { render, staticRenderFns } from "./PageNameLanguageSelector.vue?vue&type=template&id=3fc6de41&"
import script from "./PageNameLanguageSelector.vue?vue&type=script&lang=js&"
export * from "./PageNameLanguageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports